import { render, staticRenderFns } from "./SubmittedEmdAccepted.vue?vue&type=template&id=7b9644fc&scoped=true&"
import script from "./SubmittedEmdAccepted.vue?vue&type=script&lang=js&"
export * from "./SubmittedEmdAccepted.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b9644fc",
  null
  
)

export default component.exports